import { readonly, ref } from 'vue'
import { localeOptions, normalizeLocale, resolveLocale, setLocaleInUrl } from './index.mjs'

const storageKey = 'happy-pets-website-locale'

function readInitialLocale() {
  if (typeof window === 'undefined') {
    return 'zh'
  }

  const params = new URLSearchParams(window.location.search)
  let savedLocale = null
  try {
    savedLocale = window.localStorage.getItem(storageKey)
  } catch {
    // Storage can be unavailable in private browsing or embedded contexts.
  }

  return resolveLocale({
    queryLocale: params.get('lang'),
    savedLocale,
    browserLocales: window.navigator.languages || [window.navigator.language]
  })
}

const activeLocale = ref(readInitialLocale())

function applyDocumentLocale(locale) {
  if (typeof document !== 'undefined') {
    document.documentElement.lang = locale === 'zh' ? 'zh-CN' : locale
  }
}

applyDocumentLocale(activeLocale.value)

export function setActiveLocale(locale) {
  const normalizedLocale = normalizeLocale(locale) || 'zh'
  activeLocale.value = normalizedLocale
  applyDocumentLocale(normalizedLocale)

  if (typeof window === 'undefined') {
    return
  }

  try {
    window.localStorage.setItem(storageKey, normalizedLocale)
  } catch {
    // The URL still keeps the selection when persistent storage is unavailable.
  }

  const nextUrl = setLocaleInUrl(window.location.href, normalizedLocale)
  window.history.replaceState(window.history.state, '', nextUrl)
}

export function getActiveLocale() {
  return activeLocale.value
}

export function useLocale() {
  return {
    locale: readonly(activeLocale),
    localeOptions,
    setLocale: setActiveLocale
  }
}
